/* import __COLOCATED_TEMPLATE__ from './entry-list.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class PlaylistFormEntryListComponent extends Component {
  @service store;
  @tracked scrollable = true;

  listener(e) {
    console.log('listener', e);
    if (!this.scrollable) {
      e.preventDefault();
    }
  }

  @action
  helpMobileDrag() {
    this.boundListener = this.listener.bind(this);
    document.addEventListener('touchmove', this.boundListener, {
      passive: false,
    });
  }

  @action
  removeListener() {
    console.log('removeListener');
    document.removeEventListener('touchmove', this.boundListener, {
      passive: false,
    });
  }

  @action
  onDrag() {
    console.log('onDrag');
    this.scrollable = false;
  }

  @action
  onDragEnd() {
    console.log('onDragend');
    this.scrollable = true;
  }

  @action
  onDrop(el, target, source, sibling) {
    console.log('we hit onDrop', el, target, source, sibling);
    this.scrollable = true;
    this.captureOrder();
  }

  @action
  removePlaylistEntry(playlistEntry) {
    this.args.playlist.playlistEntries.removeObject(playlistEntry);
  }

  captureOrder() {
    let elements = document.querySelectorAll(
      '[data-project-id]:not(.gu-mirror)',
    );
    console.log('elements = ', elements);
    let projectIds = [];
    for (let i = 0, len = elements.length; i < len; i++) {
      let element = elements[i];
      let projectId = element.dataset.projectId;
      projectIds.push(projectId);
      let playlistEntryId = element.dataset.playlistEntryId;
      console.log('playlistEntryId = ', playlistEntryId);
      if (playlistEntryId) {
        let playlistEntry = this.store.peekRecord(
          'playlist-entry',
          playlistEntryId,
        );
        console.log('playlistEntry = ', playlistEntry);
        playlistEntry.set('order', i);
      }
    }
    console.log('projectIds = ', projectIds);
    this.args.playlist.projectIds = projectIds;
  }
}
